import { MentionMeDomainConfig } from '../../models/mention-me/mention-me-domain-config.interface';
import { MentionMeSituation } from '../../models/mention-me/mention-me-situation.enum';

export const mockMentionMeDomainConfig: MentionMeDomainConfig = {
  situation: MentionMeSituation.PostPurchaseMainsite,
  referrerOffer: 'referrerOffer',
};
